import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import RadioPanelGruppeExample from "./../../sample/_radiopanelgruppe.example.js";
import { RadioPanelGruppe } from "./../../";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#feilmelding-uten-propagering-av-feil-prop-til-children"
              }}>{`Feilmelding uten propagering av feil-prop til children`}</a></li></ol></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#bruk-av-radioref"
          }}>{`Bruk av radioRef`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <RadioPanelGruppeExample name="example-1" mdxType="RadioPanelGruppeExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<RadioPanelGruppe
  name="samplename"
  legend="Hvilken drikke er best?"
  radios={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id" },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    { label: "Ananasjuice", value: "juice3", id: "juice4id" },
  ]}
  checked={this.state.checked}
  onChange={this.onChange}
/>
`}</code></pre>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <RadioPanelGruppeExample name="example-2" feil={true} mdxType="RadioPanelGruppeExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<RadioPanelGruppe
  name="samplename"
  legend="Hvilken drikke er best?"
  radios={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id" },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    { label: "Ananasjuice", value: "juice3", id: "juice4id" },
  ]}
  checked={this.state.checked}
  onChange={this.onChange}
  feil={{ feilmelding: "Her er det en feil." }}
/>
`}</code></pre>
    <h3 {...{
      "id": "feilmelding-uten-propagering-av-feil-prop-til-children"
    }}>{`Feilmelding uten propagering av feil-prop til children`}</h3>
    <p>{`Bruk `}<inlineCode parentName="p">{`utenFeilPropagering`}</inlineCode>{`-propen for å bestemme om `}<inlineCode parentName="p">{`feil`}</inlineCode>{`-propen til `}<inlineCode parentName="p">{`RadioPanelGruppe`}</inlineCode>{` skal propageres til children.`}</p>
    <Example mdxType="Example">
  <RadioPanelGruppeExample name="example-4" feil={true} utenFeilPropagering mdxType="RadioPanelGruppeExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<RadioPanelGruppe
  name="samplename"
  legend="Hvilken drikke er best?"
  radios={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id", feil },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    { label: "Ananasjuice", value: "juice3", id: "juice4id" },
  ]}
  checked={this.state.checked}
  onChange={this.onChange}
  feil={{ feilmelding: "Feilmeldingstekst må gjenta nøkkelord fra label" }}
  utenFeilPropagering
/>
`}</code></pre>
    <h2 {...{
      "id": "bruk-av-radioref"
    }}>{`Bruk av radioRef`}</h2>
    <Example mdxType="Example">
  <RadioPanelGruppeExample button name="example-3" mdxType="RadioPanelGruppeExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const juice1Ref = useRef(null);

<RadioPanelGruppe
  name="samplename"
  legend="Hvilken drikke er best?"
  radios={[
    {
      label: "Eplejuice",
      value: "juice1",
      id: "juice1id",
      radioRef: (ref) => (juice1Ref.current = ref),
    },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id" },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    { label: "Ananasjuice", value: "juice3", id: "juice4id" },
  ]}
  checked={this.state.checked}
  onChange={this.onChange}
  feil={{ feilmelding: "Her er det en feil." }}
/>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      